<div class="d-flex flex-column h-100 pe-1" caLocalizationScope="navigation" [formGroup]="impersonationForm">
  <div class="mt-1" data-automation-id="legal-section">
    <label class="form-label-top">{{ 'authorizeImpersonationLabel' | caLocalize }}:</label>
    <div
      class="mt-1 pb-2 border-bottom d-none d-sm-block terms-scroll body-70"
      data-automation-id="user-impersonation-terms"
    >
      <ca-impersonation-terms></ca-impersonation-terms>
    </div>
    <div class="mt-1 d-block d-sm-none">
      <a class="link link-primary" (click)="showImpersonationDisclosure()">{{
        'impersonationDisclosure' | caLocalize
      }}</a>
    </div>
  </div>

  <div class="mt-3" data-automation-id="support-section">
    <label class="form-label-top">{{ 'supportAssistLabel' | caLocalize }}<span class="text-danger">*</span></label>
    <div class="pt-1 d-flex justify-content-start gap-2">
      <f-single-choice-chip-group
        [items]="supportRequestStatusItems$ | async"
        [selectedId]="selectedSupportRequestStatus"
        [chipSize]="ChipSize.Sm"
        (select)="onSupportStatusChange($event)"
        data-automation-id="support-assisting-chips"
      >
      </f-single-choice-chip-group>
    </div>
  </div>

  <div class="mt-3" data-automation-id="impersonation-window-section">
    <label class="form-label-top"
      >{{ 'impersonationWindowLabel' | caLocalize }}<span class="text-danger">*</span></label
    >
    <div
      class="pt-1"
      [class.is-invalid]="
        impersonationForm.get('impersonationWindow')?.touched &&
        impersonationForm.get('impersonationWindow')?.hasError('required')
      "
    >
      <f-dropdown
        class="impersonation-duration-dropdown"
        [text]="impersonationDurationDisplayText || ('impersonationWindowPlaceholder' | caLocalize)"
        [btnStyle]="'btn-outline w-100 text-start'"
        [menuCssClass]="'w-100 impersonation-duration-menu'"
      >
        <f-list>
          @for (item of impersonationDurationItems$ | async; track item.value) {
          <f-list-item fDropdownItem (click)="onImpersonationDurationChange(item)" class="impersonation-duration-item">
            <div class="d-flex flex-column">
              <span>{{ item.displayText }}</span>
              @if (item.value === impersonationDuration.ThreeSixtyFiveDays) {
              <small class="text-muted">{{ 'threeSixtyFiveDaysSecondary' | caLocalize }}</small>
              }
            </div>
          </f-list-item>
          }
        </f-list>
      </f-dropdown>
    </div>
  </div>

  @if (expirationDate) {
  <div class="mt-2">
    <small class="text-muted">
      {{ 'impersonationWindowExpiresMessage' | caLocalize }} {{ expirationDate.toISO() | caDate }},
      {{ expirationDate.toISO() | caTime : { ignoreTimeZoneLabel: true } }}
    </small>
  </div>

  } @if (showImpersonationWindowError) {
  <div class="invalid-feedback d-block">
    {{ 'fieldIsRequiredError' | caLocalize }}
  </div>
  }
  <div class="mt-3" data-automation-id="access-scope-section">
    <label class="form-label-top">{{ 'authorizeAccessLabel' | caLocalize }}</label>
    <div class="pt-1 d-flex justify-content-start gap-2">
      <f-single-choice-chip-group
        [items]="accessScopeItems"
        [selectedId]="selectedAccessScope"
        [chipSize]="ChipSize.Sm"
        data-automation-id="support-assisting-chips"
      >
      </f-single-choice-chip-group>
    </div>
  </div>

  <div class="mt-3 mb-4" data-automation-id="impersonation-note-container">
    <label class="form-label-top">{{ 'notesLabel' | caLocalize }}</label>
    <textarea
      class="body-50 form-control form-control-outline form-control-noresize h-75"
      id="impersonationNote"
      rows="5"
      [placeholder]="'impersonationNotePlaceholder' | caLocalize"
      data-automation-id="impersonation-note"
      formControlName="notes"
      [class.is-invalid]="invalid"
    ></textarea>

    @if (maxLengthError) {
    <div class="invalid-feedback">
      {{ 'impersonationNoteMaxChar' | caLocalize : { maxCharNumber: MAX_LENGTH } }}
    </div>
    }
  </div>

  <ng-template fDrawerFooterTemplate>
    @if (impersonationForm.invalid && isValidationFormErrorMessageShown) {
    <div class="mb-4">
      <f-inline-alert
        [type]="alertType.Danger"
        (hideClick)="setValidationFormErrorMessage(false)"
        rootCssClass="mt-1 mb-3"
      >
        <div data-automation-id="custom-field-form-system-error">{{ 'correctHighlightedFields' | caLocalize }}</div>
      </f-inline-alert>
    </div>
    }
    <div class="footer-with-buttons">
      <button class="btn btn-primary" data-automation-id="save-button" (click)="onSubmit()">
        {{ 'authorize' | caLocalize }}
      </button>
      <button class="btn btn-secondary" data-automation-id="discard-changes-button" (click)="close()">
        {{ 'cancel' | caLocalize }}
      </button>
    </div>
  </ng-template>
</div>
